import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

interface RankingVisualizationProps {
  shouldAnimate: boolean;
  shouldHideResults: boolean;
  results: Array<{ label: string; id: number; score: number; index: number }>;
}

export const RankingVisualization = ({
  shouldAnimate,
  shouldHideResults,
  results,
}: RankingVisualizationProps) => {
  return (
    <Box width="100%" height="100%" alignItems="center" justifyContent="center">
      <Text fontSize="300" color="onPrimaryWeak">
        {shouldAnimate ? 'Animating...' : 'Static Visualization'}
      </Text>
      <Text fontSize="300" color="onPrimaryWeak">
        {shouldHideResults ? 'Results are hidden' : 'Results are visible'}
      </Text>
      <Text fontSize="300" color="onPrimaryWeak">
        {JSON.stringify(results)}
      </Text>
    </Box>
  );
};
